"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-unused-expressions */
const react_1 = __importStar(require("react"));
const isServer_1 = __importDefault(require("../../utils/isServer"));
const customEvent = 'hydrate';
let cachedIntersectionObserver;
const getIntersectionObserver = (rootMargin) => {
    if (isServer_1.default || !IntersectionObserver) {
        return null;
    }
    if (cachedIntersectionObserver) {
        return cachedIntersectionObserver;
    }
    cachedIntersectionObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting || entry.intersectionRatio > 0) {
                entry.target.dispatchEvent(new CustomEvent(customEvent));
            }
        });
    }, {
        rootMargin,
    });
    return cachedIntersectionObserver;
};
// React currently throws a warning when using useLayoutEffect on the server.
const useIsomorphicLayoutEffect = !isServer_1.default ? react_1.useLayoutEffect : react_1.useEffect;
const LazyHydrate = (_a) => {
    var { ssrOnly, whenVisible, whenIdle, promise, // pass a promise which hydrates
    on = [], children, didHydrate, // callback for hydration
    rootMargin = '100px' } = _a, rest = __rest(_a, ["ssrOnly", "whenVisible", "whenIdle", "promise", "on", "children", "didHydrate", "rootMargin"]);
    const childRef = (0, react_1.useRef)(null);
    // Always render on server
    const [hydrated, setHydrated] = (0, react_1.useState)(isServer_1.default);
    useIsomorphicLayoutEffect(() => {
        var _a;
        // No SSR Content
        if (!((_a = childRef.current) === null || _a === void 0 ? void 0 : _a.hasChildNodes())) {
            setHydrated(true);
        }
    }, []);
    (0, react_1.useEffect)(() => {
        var _a, _b;
        if (ssrOnly || hydrated) {
            return undefined;
        }
        const cleanupFns = [];
        const hydrate = () => {
            setHydrated(true);
            if (didHydrate) {
                didHydrate();
            }
        };
        if (promise) {
            promise.then(hydrate).catch(hydrate);
        }
        const events = Array.isArray(on) ? on.slice() : [on];
        if (whenVisible) {
            const io = getIntersectionObserver(rootMargin);
            if (io && ((_a = childRef.current) === null || _a === void 0 ? void 0 : _a.childElementCount)) {
                // As root node does not have any box model, it cannot intersect.
                const el = (_b = childRef.current) === null || _b === void 0 ? void 0 : _b.children[0];
                io.observe(el);
                events.push(customEvent);
                cleanupFns.push(() => {
                    io.unobserve(el);
                });
            }
            else {
                return hydrate();
            }
        }
        if (whenIdle) {
            // @ts-ignore
            if (typeof requestIdleCallback !== 'undefined') {
                // @ts-ignore
                const idleCallbackId = requestIdleCallback(hydrate, { timeout: 500 });
                cleanupFns.push(() => {
                    // @ts-ignore
                    cancelIdleCallback(idleCallbackId);
                });
            }
            else {
                const id = setTimeout(hydrate, 1000);
                cleanupFns.push(() => {
                    clearTimeout(id);
                });
            }
        }
        events.forEach((event) => {
            var _a;
            (_a = childRef.current) === null || _a === void 0 ? void 0 : _a.addEventListener(event, hydrate, {
                once: true,
                capture: true,
                passive: true,
            });
            cleanupFns.push(() => {
                var _a;
                (_a = childRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener(event, hydrate, { capture: true });
            });
        });
        return () => {
            while (cleanupFns.length) {
                const cleanupFn = cleanupFns.pop();
                if (cleanupFn) {
                    cleanupFn();
                }
            }
        };
    }, [hydrated, on, ssrOnly, whenVisible, didHydrate, promise]);
    return hydrated ? (react_1.default.createElement("div", Object.assign({ ref: childRef, style: { display: 'contents' } }, rest), children)) : (react_1.default.createElement("div", Object.assign({ ref: childRef, style: { display: 'contents' }, suppressHydrationWarning: true }, rest, { dangerouslySetInnerHTML: { __html: '' } })));
};
exports.default = LazyHydrate;
//# sourceMappingURL=LazyHydrate.js.map